import { Box, Paper, Typography, styled } from "@mui/material"

import Button from "components/ui/Button"
import { colors } from "theme"

export const Card = styled(Paper)(({ theme }) => ({
  boxShadow: "12px 14px 23px -2px rgb(0 0 0 / 3%)",
  borderRadius: "26px",
  padding: "58px",
  margin: "0 0 16px 0",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    padding: "16px",
  },
}))

export const Info = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}))

export const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    fontSize: "1.125rem",
    marginBottom: "0",
  },
}))

export const Description = styled(Typography)(() => ({
  fontSize: "0.875rem",
  margin: "0",
  padding: "0",
}))

export const Actions = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  [theme.breakpoints.down("md")]: {
    flex: 0.5,
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "center",
  },
}))

const Btn = styled(Button)(({ theme }) => ({
  borderRadius: "21px",
  fontSize: "0.875rem",
  textTransform: "inherit",
  height: "36px",
  padding: "0 20px",
  width: "144px",
  [theme.breakpoints.down("md")]: {
    maxWidth: "100%",
    margin: "5px 0",
    width: "100%",
  },
}))

export const Cancel = styled(Btn)(({ theme }) => ({
  background: "rgba(172, 172, 172, 0.1)",
  color: theme.palette.common.black,
}))

export const Upgrade = styled(Btn)(({ theme }) => ({
  background: colors.lightPersianGreen,
  color: theme.palette.primary.main,
  [theme.breakpoints.up("md")]: {
    margin: "0 10px",
  },
}))

export const BankPay = styled(Btn)(({ theme }) => ({
  background: colors.lightPersianGreen,
  color: theme.palette.primary.main,
  [theme.breakpoints.up("md")]: {
    margin: "0 10px",
  },
}))

export const Status = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  margin: "0 10px",
  [theme.breakpoints.down("sm")]: {
    margin: "5px 0",
  },
}))

export const Help = styled(Typography)(() => ({
  color: colors.indigo,
  fontSize: "0.875rem",
  fontWeight: "500",
  lineHeight: "normal",
  margin: "7px 0 0 0",
}))

export const Badge = styled(Typography)(({ theme }) => ({
  backgroundColor: theme.palette.common.black,
  color: theme.palette.common.white,
  borderRadius: "12.5px",
  fontSize: "0.625rem",
  fontWeight: "500",
  lineHeight: "normal",
  padding: "7px 12px",
}))

export const BadgeSuccess = styled(Badge)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}))

export const BadgeError = styled(Badge)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
}))

export const BadgeGray = styled(Badge)(() => ({
  backgroundColor: colors.romanSilver,
}))
